import Login from "../login/screen";
import Registration from "../registration/screen";
import DetailPage from "../detail_page/screen";
import "./style.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RegistrationType from "../registration_type/screen";
import ResetPasswordScreen from "../reset_password/screen";
import ViewUsersPage from "../view_users/screen";
import { IITD_TITLE } from "../../utils/constants";
import BackButton from "../../components/back_button";
import DashboardPage from "../dashboard/screen";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <div className="form-div">
        <div className="left-div">
          <h1>{IITD_TITLE}</h1>
          <Login />
        </div>
        <div className="right-div">
          <img
            className="side-image"
            src="image/iitd-img.png"
            alt="IIT-Delhi"
          ></img>
        </div>
      </div>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <div className="form-div">
        <div className="left-div">
          <BackButton />
          <h1>{IITD_TITLE}</h1>
          <ResetPasswordScreen />
        </div>
        <div className="right-div">
          <img
            className="side-image"
            src="image/iitd-img.png"
            alt="IIT-Delhi"
          ></img>
        </div>
      </div>
    ),
  },
  {
    path: "/registration-type",
    element: <RegistrationType />,
  },
  {
    path: "/registration",
    element: <Registration />,
  },
  {
    path: "/detail",
    element: <DetailPage />,
  },
  {
    path: "/view-users",
    element: <ViewUsersPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
]);

function Main() {
  return (
    <div>
      <img
        className="background-image"
        src="image/iitd.jpg"
        alt="IIT-Delhi"
      ></img>
      <RouterProvider router={router} />
    </div>
  );
}

export default Main;
